import '~/sass/pages/offers.scss';

import { init } from '@/components/owner-news-extent';

const { $ } = window;
$(document).ready(() => {
  init();
});
